import * as React from 'react';
import Title from 'core/components/Title';
import * as styles from './BlogListHero.module.scss';

function BlogListHero(): React.ReactElement {
    return (
        <Title
            title="Everything You Want To Know About Your Pet"
            Component="h1"
            titleClassName={styles.title}
            className={styles.root}
        />
    );
}

export default BlogListHero;
